__turbopack_context__.v({
  "modal": "VVV50G_modal",
  "modal_backdrop": "VVV50G_modal_backdrop",
  "modal_dialog": "VVV50G_modal_dialog",
});
